import { MapContentLayer } from '../MapContentLayer';
import { FilterSpecification, LayerSpecification, LineLayerSpecification, Map } from 'maplibre-gl';
import { MapContentVectorSource } from '../MapContentVectorSource';
import { TrackStyles } from '../../../../../configuration/model/TrackStyles';
import { StormShift } from '../../../../models/storm.model';
import { MapStyles } from '../../../../../configuration/map-styles';

export class StormTrackLayer extends MapContentLayer {
  private filterFrom: number;
  private filterTo: number;

  constructor(
    source: MapContentVectorSource,
    private trackStyles: TrackStyles,
    private stormShifts: StormShift[]
  ) {
    super('storm-track-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'line',
      source: this.sourceRef.sourceId,
      'source-layer': 'track',
      // filter: undefined,
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': this.trackStyles.shiftPlowNormal.color,
        'line-opacity': this.trackStyles.shiftPlowNormal.opacity,
        'line-width': this.trackStyles.shiftPlowNormal.width,
      },
    } as LineLayerSpecification;
  }

  filterByTime(map: Map, timeFrom: number, timeTo: number) {
    this.filterFrom = timeFrom;
    this.filterTo = timeTo;

    // startunixtime
    // endunixtime
    const filter: any[] = ['all'];
    if (!!timeFrom) {
      filter.push(['>=', ['get', 'startunixtime'], timeFrom]);
    }
    if (!!timeTo) {
      filter.push(['<=', ['get', 'endunixtime'], timeTo]);
    }

    map.setFilter(this.layerId, filter as FilterSpecification);
  }

  highlightByShiftId(map: Map, shiftId: number) {
    if (map) {
      let paintProperty;
      if (!shiftId) {
        paintProperty = this.trackStyles.shiftPlowNormal.color;
      } else {
        paintProperty = ['case', ['==', ['get', 'sessionkey'], shiftId], MapStyles.PAUSED_COLOR, this.trackStyles.shiftPlowNormal.color];
      }
      map.setPaintProperty(
        this.layerId,
        'line-color',
        paintProperty,
      );
    }
  }
}
